// extracted by mini-css-extract-plugin
module.exports = {"root":"tweet-container_root__w21RQ","article":"tweet-container_article__v_yww"};